/* Which contract details may stay empty, as the contract page's Edit shows it.
 *
 * A contract added in Legal belongs to no deal, so its position and commence
 * date may stay empty. A deal contract keeps both: the server refuses them
 * empty (backend legal/serializers.py LegalContractUpdateSerializer), so the
 * screen marks them required and offers no empty choice.
 */

export const dealFieldsRequired = (contract) => contract?.commodity_type !== 'general';

// The position choices for Edit: an added contract can say "Not set", so a
// blank position is shown as blank instead of as the first real choice.
export const positionOptions = (contract, options) => (
  dealFieldsRequired(contract) ? options : [{ value: '', label: 'Not set' }, ...options]
);
